<img class="skull-gif" src="skull.gif" alt="skull animation GIF">

<style>
  .skull-gif {
		width: 150px;
	}
</style>